import { useTranslation } from "react-i18next";

/**
 * Resolves an event-detail tab key to its translated label. Listed as literal `t("…")`
 * here (the useXxxLabel pattern) so i18next-parser keeps the keys — the tab bar is
 * data-driven, so `t(tab.labelKey)` alone would get pruned from the locale files.
 */
export const useEventTabLabel = () => {
  const { t } = useTranslation();
  const labels: Record<string, string> = {
    Request: t("Request"),
    Qualification: t("Qualification"),
    Bids: t("Bids"),
    Evaluation: t("Evaluation"),
    Award: t("Award"),
    Communication: t("Communication"),
    Tasks: t("Tasks"),
    Team: t("Team"),
  };
  return (key: string): string => labels[key] ?? key;
};
